import { Divider } from '@mui/material';
import { observer } from 'mobx-react';
import { memo, useEffect, useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';
import CabecalhoProcesso from './CabecalhoProcesso';
import CabecalhoProcessoPreSessao from './CabecalhoProcessoPreSessao';

interface PainelProcessoProps {
    registro: {
        numeroProcesso: string;
        processo: {
            numeroCompleto: string;
        };
    };
    scrollRoot: HTMLElement | null;
    idListaProcessos: string;
    idProcessosEmExibicao: string;
    isPreSessao: boolean;
    isProcessoApregoado: boolean;
    isProcessoExpandido: boolean;
}

const PainelProcessoBase = observer(
    ({
        registro,
        scrollRoot,
        idListaProcessos,
        idProcessosEmExibicao,
        isPreSessao,
        isProcessoApregoado,
        isProcessoExpandido
    }: PainelProcessoProps) => {
        const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
        const [isRendered, setIsRendered] = useState(false);
        const [classNameLinhaProcesso, setClassNameLinhaProcesso] = useState('linhaProcesso');

        useEffect(() => {
            let newClassName = 'linhaProcesso';

            if (isProcessoApregoado && isProcessoExpandido) {
                newClassName = 'processoApregoado';
            } else if (isProcessoApregoado) {
                newClassName = 'processoApregoadoNaoExpandido';
            } else if (isProcessoExpandido) {
                newClassName = 'processoExpandido';
            }

            setClassNameLinhaProcesso(newClassName);
        }, [isProcessoApregoado, isProcessoExpandido]);

        const handleChangeObserver = (inView: boolean) => {
            if (idProcessosEmExibicao === idListaProcessos) {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }

                timeoutRef.current = setTimeout(
                    () => {
                        setIsRendered(inView);
                    },
                    inView ? 50 : 500
                );
            }
        };

        const renderCarregando = () => {
            return (
                <div style={{ height: '60px', padding: '20px' }}>Carregando {registro.processo.numeroCompleto}...</div>
            );
        };

        const renderCabecalhoProcesso = () => {
            return isPreSessao ? (
                <CabecalhoProcessoPreSessao registro={registro} />
            ) : (
                <CabecalhoProcesso registro={registro} />
            );
        };

        return (
            <div
                key={registro.numeroProcesso}
                id={idListaProcessos + 'divProcesso-' + registro.numeroProcesso}
                style={{ padding: 0, margin: 0, width: '100%' }}
                className={classNameLinhaProcesso}
            >
                <InView
                    as="div"
                    root={scrollRoot}
                    onChange={handleChangeObserver}
                    rootMargin="800px 0px"
                >
                    {isRendered ? renderCabecalhoProcesso() : renderCarregando()}
                </InView>
                <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }} />
            </div>
        );
    }
);

const PainelProcesso = memo(PainelProcessoBase);
PainelProcesso.displayName = 'PainelProcesso';

export default PainelProcesso;
